import Glider from 'glider-js';
import { MQ } from '../tools/MQ.js';

export const init = () => {
	const jsArticleCarousel = document.querySelectorAll('.js-article-carousel'),
		jsStickyServicesFilter = document.querySelectorAll('.js-sticky-filter'),
		jsServiceCarousel = document.querySelectorAll('.js-service-carousel');

	Array.from(jsArticleCarousel).forEach(initCarousel);

	if (!jsStickyServicesFilter.length) {
		Array.from(jsServiceCarousel).forEach(initCarousel);
	}

	function initCarousel(list) {
		if (parseInt(list.dataset.items) === 2) {
			if (MQ('mdDown')) {
				new Glider(list, {
					slidesToShow: 1,
					slidesToScroll: 1,
					draggable: true,
					scrollLock: true,
					dots: list.nextElementSibling,
					responsive: [
						{
							breakpoint: 750,
							settings: {
								dots: false,
								slidesToShow: list.dataset.items,
								slidesToScroll: 'auto',
							},
						},
					],
				});
			}
		}

		if (parseInt(list.dataset.items) === 3) {
			if (MQ('lgDown')) {
				new Glider(list, {
					slidesToShow: 1,
					slidesToScroll: 1,
					draggable: true,
					scrollLock: true,
					dots: list.nextElementSibling,
					responsive: [
						{
							breakpoint: 750,
							settings: {
								slidesToShow: 2,
							},
						},
						{
							breakpoint: 1000,
							settings: {
								dots: false,
								slidesToShow: list.dataset.items,
							},
						},
					],
				});
			}
		}
	}
};
